import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { IconButton, Box } from "@material-ui/core";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import PropTypes from "prop-types";
import ActiveDirectoryTable from './../ActiveDirectoryTable/ActiveDirectoryTable';
import { TextInput } from "../../../FlowConfigurationInputs/TextInput/NewTextInput";

// TabPanel styling
function TabPanel({ children, value, index }) {
  return <div>{value === index && <Box>{children}</Box>}</div>;
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

/**
 * @Description this page Active Directory  Library's Update User  Action's configuration form
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Param       variableRenbder - variable render
 * @Returns     div element
 * @Author      Kerem Karadeniz
 */
function UpdateUser({ action, variables, setOpenVariable }) {
  const { t } = useTranslation();
  const label = "CONTENT.CONFIGURATION-FORM.ACTIVE-DIRECTORY.CREATE-USER.";
  const [data, setData] = useState([]);
  const [index, setIndex] = useState(-1);
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState(0);
  // set initial data 
  useEffect(() => {
    if (!action.fields.customAttributes) {
      action.fields.customAttributes = { value: [] };
    } else {
      setData(action.fields.customAttributes.value);
    }
    if (!action.fields.filter) {
      action.fields.filter = { value: 'username' }
    }
    else {
      if (action.fields.filter.value === "username") setValue(0)
      else setValue(1)
    }
    if (!action.fields.logonName) {
      action.fields.logonName = { value: '' }
    }
  }, [action, variables]);

  useEffect(() => {
    if (data.length > 0) {
      action.fields.customAttributes.value = data;
    }

  }, [data, action.fields.customAttributes]);


  //open modal
  function handleOpenEdit(indx, setState) {
    setIndex(indx);
    setState(true);
  }

  // changed tabs panel
  const handleChange = (newValue) => {
    console.log(action.fields);
    console.log(action.fields.logonName);
    console.log(action.fields.userName);
    if (newValue === 0) {
      action.fields.filter.value = 'username';
      action.fields.userName = { value: '', isRequired: true };
      action.fields.logonName = { value: '', isRequired: false };
    } else {
      action.fields.filter.value = 'logonname';
      action.fields.logonName = { value: '', isRequired: true };
      action.fields.userName = { value: '', isRequired: false };
    }
    setValue(newValue);
  };
  return (
    <div>
      <div className="form-element">
        <div className="condition-tabs">
          <button
            className={value === 0 ? 'condition-active' : ''}
            onClick={() => handleChange(0)}>
            {t(label + "USERNAME")}
          </button>
          <button
            className={value === 1 ? 'condition-active' : ''}
            onClick={() => handleChange(1)}>
            {t(label + "LOGON-NAME")}
          </button>
        </div>
        <TabPanel value={value} index={0}>
          <TextInput
            action={action}
            isRequired={false}
            inputName="userName"
            variables={variables}
            setOpenVariable={setOpenVariable}
            fieldType="string"
            displayName={t(label + "USERNAME")}
          />
          <small style={{ color: "var(--celeste)" }}>{"{eg:JohnBrown }"}</small>
        </TabPanel>
        <TabPanel value={value} index={1}>
          <TextInput
            action={action}
            isRequired={false}
            inputName="logonName"
            variables={variables}
            setOpenVariable={setOpenVariable}
            fieldType="string"
            displayName={t(label + "LOGON-NAME")}
          />
          <small style={{ color: "var(--celeste)" }}>{"{eg:johnbrown }"}</small>
        </TabPanel>
      </div>
      <div className="form-element">
        {t(label + "FIRST-NAME")}
        <TextInput
          action={action}
          inputName="firstName"
          variables={variables}
          setOpenVariable={setOpenVariable}
          isRequired={false}
          fieldType="string"
          displayName={t(label + "FIRST-NAME")}
        />
      </div>
      <div className="form-element">
        {t(label + "LAST-NAME")}
        <TextInput
          action={action}
          inputName="lastName"
          variables={variables}
          setOpenVariable={setOpenVariable}
          isRequired={false}
          fieldType="string"
          displayName={t(label + "LAST-NAME")}
        />
      </div>
      <div className="form-element">
        {t(label + "DISPLAY-NAME")}
        <TextInput
          action={action}
          inputName="displayName"
          variables={variables}
          setOpenVariable={setOpenVariable}
          isRequired={false}
          fieldType="string"
          displayName={t(label + "DISPLAY-NAME")}
        />
      </div>
      <div className="form-element">
        {t(label + "EMAIL")}
        <TextInput
          action={action}
          inputName="email"
          variables={variables}
          setOpenVariable={setOpenVariable}
          isRequired={false}
          fieldType="string"
          displayName={t(label + "EMAIL")}
        // inputMode="email"
        />
      </div>
      <div className="form-element">
        {t(label + "DESCRIPTION")}
        <TextInput
          action={action}
          inputName="description"
          variables={variables}
          setOpenVariable={setOpenVariable}
          isRequired={false}
          fieldType="string"
          displayName={t(label + "DESCRIPTION")}
        />
      </div>
      <div className="form-element">
        {t(label + "DEPARTMENT")}
        <TextInput
          action={action}
          inputName="department"
          variables={variables}
          setOpenVariable={setOpenVariable}
          isRequired={false}
          fieldType="string"
          displayName={t(label + "DEPARTMENT")}
        />
      </div>
      <div className="form-element">
        {t(label + "TITLE")}
        <TextInput
          action={action}
          inputName="title"
          variables={variables}
          setOpenVariable={setOpenVariable}
          isRequired={false}
          fieldType="string"
          displayName={t(label + "TITLE")}
        />
      </div>
      <div className="form-element">
        <div className="form-element">
          Custom Attributes
          <IconButton
            style={{ padding: 0, float: "right" }}
            onClick={() => setOpen(true)}
          >
            <AddCircleOutlineIcon style={{ paddingTop: 5, color: "#8C90A2" }} />
          </IconButton>
        </div>
        <div className="form-element">
          <table style={{ width: "90%" }}>
            <thead>
              <tr>
                <th>Attribute Name</th>
                <th>Attribute Value</th>
                <th> </th>
              </tr>
            </thead>
            <tbody>
              {Array.isArray(data) &&
                data.map((item, indx) => (
                  <tr key={indx}>
                    <td><span className="content-overflow" style={{ width: 85 }}>{item.key}</span></td>
                    <td><span className="content-overflow" style={{ width: 85 }}>{item.value}</span></td>
                    <td onClick={() => handleOpenEdit(indx, setOpen)}>
                      <EditOutlinedIcon />
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
      {open && (
        <ActiveDirectoryTable
          index={index}
          setOpen={setOpen}
          setOpenVariable={setOpenVariable}
          inputName="customAttributes"
          action={action}
          variables={variables}
          setDictionaryTable={setData}
          dictionaryTable={data}
          setIndex={setIndex}
          titles={["Attribute Name", "Attribute Value"]}
        />
      )}
    </div>
  );
}

export default UpdateUser;
